import React from "react";
import { useQueryClient } from "react-query";
import moment from "moment";
import { LocationIcon, YouTubeIcon, VkIcon, PhoneIcon } from "../../_assests";
import {
  Wrapper,
  Copyright,
  Privacy,
  Address,
  Contacts,
  Contact,
  Phone,
  Social,
} from "./Footer.styled";

interface Props {
  children?: React.ReactNode;
  className?: string;
}

export default function Footer({ children, className }: Props) {
  const date = useQueryClient().getQueryData("date");

  return (
    <Wrapper className={className}>
      {children}

      <Copyright href="https://eric-yanao.ru/" target="_blank">
        ©{moment(date).format("YYYY")} АО «Единый расчетно-информационный центр
        ЯНАО»
      </Copyright>

      <Privacy
        href="https://www.vostok-electra.ru/upload/medialibrary/ca1/polzovatelskoe-soglashenie.pdf"
        target="_blank"
      >
        Пользовательское соглашение
      </Privacy>

      <Address>
        <LocationIcon />
        <span>629008, ЯНАО, г. Салехард, ул. Броднева, 55</span>
      </Address>

      <Phone>
        <PhoneIcon />8 800 250 28 74
      </Phone>

      <Contacts>
        <Contact>
          <a
            href="https://www.youtube.com/channel/UCPRAhaGv-4JIqj5kmymRsrw"
            target="_blank"
            rel="noreferrer"
          >
            <YouTubeIcon />
          </a>
        </Contact>

        <Contact>
          <a
            href="https://vk.com/public200566212"
            target="_blank"
            rel="noreferrer"
          >
            <VkIcon />
          </a>
        </Contact>
      </Contacts>
      <Social>Мы в социальных сетях</Social>
    </Wrapper>
  );
}
